/**
 * @ngdoc directive
 * @name ng.directive:vBannerOwner
 * @param vue
 */

export default (vue) => {
    vue.el.querySelector('a').href = vue.el.parentNode.dataset.provider;
};